import { refresh,selectCarFingerAuthorizeList,insertAuthorize,fingerWarehouseAuthorize,clearAuthorize,selectDriverAuthorizeList,deleteAuthorize,selectCarFingerWarehouse } from "../../api/config/modules/FingerprintAuthorization";

const state = {
    selectCarFingerAuthorizeList: {},
    insertAuthorize: {},
    fingerWarehouseAuthorize: {},
    clearAuthorize: {},
    selectDriverAuthorizeList: {},
    deleteAuthorize: {},
    refresh: {},
    selectCarFingerWarehouse: {}
};

const mutations = {
  SET_SELECTCARFINGERAUTHORIZELIST: (state, selectCarFingerAuthorizeList) => {
    state.selectCarFingerAuthorizeList = selectCarFingerAuthorizeList;
  },
  SET_INSERTAUTHORIZE: (state, insertAuthorize) => {
    state.insertAuthorize = insertAuthorize;
  },
  SET_FINGERWAREHOUSEAUTHORIZE: (state, fingerWarehouseAuthorize) => {
    state.fingerWarehouseAuthorize = fingerWarehouseAuthorize;
  },
  SET_CLEARAUTHORIZE: (state, clearAuthorize) => {
    state.clearAuthorize = clearAuthorize;
  },
  SET_SELECTDRIVERAUTHORIZELIST: (state, selectDriverAuthorizeList) => {
    state.selectDriverAuthorizeList = selectDriverAuthorizeList;
  },
  SET_DELETEAUTHORIZE: (state, deleteAuthorize) => {
    state.deleteAuthorize = deleteAuthorize;
  },
  SET_REFRESH: (state, refresh) => {
    state.refresh = refresh;
  },
  SET_SELECTCARFINGERWAREHOUSE: (state, selectCarFingerWarehouse) => {
    state.selectCarFingerWarehouse = selectCarFingerWarehouse;
  },
};

const actions = {
  GET_SELECTCARFINGERAUTHORIZELIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectCarFingerAuthorizeList(data)
        .then((res) => {
          commit("SET_SELECTCARFINGERAUTHORIZELIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        insertAuthorize(data)
        .then((res) => {
          commit("SET_INSERTAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_FINGERWAREHOUSEAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        fingerWarehouseAuthorize(data)
        .then((res) => {
          commit("SET_FINGERWAREHOUSEAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_CLEARAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      clearAuthorize(data)
        .then((res) => {
          commit("SET_CLEARAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTDRIVERAUTHORIZELIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectDriverAuthorizeList(data)
        .then((res) => {
          commit("SET_SELECTDRIVERAUTHORIZELIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        deleteAuthorize(data)
        .then((res) => {
          commit("SET_DELETEAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_REFRESH: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      refresh(data)
        .then((res) => {
          commit("SET_REFRESH", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCARFINGERWAREHOUSE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCarFingerWarehouse(data)
        .then((res) => {
          commit("SET_SELECTCARFINGERWAREHOUSE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
